import MainLayout from '@/components/layout/MainLayout.vue';
import moment from 'moment';
import axios from "axios";
import { mapGetters } from "vuex";
import store from "@/store";
import { fetchNotificationCount } from "@/services/common/notification-service";

export default {
    name: "teacherNotificationDetail",

    components: {
        MainLayout
    },

    data() {
        return {
            notification: {
                notification_id: "",
                message: "",
                insert_time: "",
            }
        };
    },

    computed: {
        ...mapGetters(["teacherId", "studentId", "userType"]),
    },

    filters: {
        shorttext(value, limit) {
            if (value) {
                return value.substring(0, limit);
            }
        },
        setMoment: function (date) {
            return moment(date).format("DD MMMM YYYY");
        }
    },
    
    methods: {
        getNotificationDetail() {
            // axios.get("/teacher/notification/detail/" + this.$route.params.id)
            axios.get("/my/notification/" + this.$route.params.id)
                .then((response) => {
                    this.notification = response.data;
                    store.commit("setNotificationCount", 0);
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("Teacher Notification Detail Error", error);
                });
        },
    },

    mounted() {
        this.getNotificationDetail();
        fetchNotificationCount();
    }
};
